import { num, pct } from "../../../lib/format";
import { FieldPair, Section } from "./section";

interface FinancialData {
  sModal: number | null;
  eModal: number | null;
  percentChange: number | null;
  age: number | null;
  feesPercentage: number | null;
  demolitionPercentage: number | null;
  gst: number | null;
  inflationDemoPlanMonths: number | null;
  inflationConstructionMonths: number | null;
  inflationYear1: number | null;
  inflationYear2: number | null;
  inflationYear3: number | null;
  inflationYear4: number | null;
}

function numericValue(v: string): React.ReactElement {
  return <span className="tabular-nums">{v}</span>;
}

export function SectionFinancial({ data }: { data: FinancialData }): React.ReactElement {
  return (
    <Section id="financial" title="Financial Configuration">
      <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-7 gap-4 mb-3">
        <FieldPair label="S Modal" value={numericValue(num(data.sModal))} />
        <FieldPair label="E Modal" value={numericValue(num(data.eModal))} />
        <FieldPair label="% Change" value={numericValue(pct(data.percentChange))} />
        <FieldPair label="Age" value={numericValue(num(data.age))} />
        <FieldPair label="Fees %" value={numericValue(pct(data.feesPercentage))} />
        <FieldPair label="Demolition %" value={numericValue(pct(data.demolitionPercentage))} />
        <FieldPair label="GST Rate" value={numericValue(pct(data.gst))} />
      </div>
      <h3 className="text-sm font-medium text-muted-foreground mb-3">Inflation Metrics</h3>
      <div className="grid grid-cols-3 sm:grid-cols-6 gap-4">
        <FieldPair label="Demo/Plan Months" value={numericValue(num(data.inflationDemoPlanMonths))} />
        <FieldPair label="Construction Months" value={numericValue(num(data.inflationConstructionMonths))} />
        <FieldPair label="Year 1" value={numericValue(pct(data.inflationYear1))} />
        <FieldPair label="Year 2" value={numericValue(pct(data.inflationYear2))} />
        <FieldPair label="Year 3" value={numericValue(pct(data.inflationYear3))} />
        <FieldPair label="Year 4" value={numericValue(pct(data.inflationYear4))} />
      </div>
    </Section>
  );
}
